import { useSelector } from "react-redux";
import { selectDisplayCurrency } from "@shared/slices/common.slice";
import { useMemo } from "react";
import { isContractsSymbol } from "@shared/utils/misc";
import { skipToken } from "@reduxjs/toolkit/query";
import useSocket from "@shared/features/socket/useSocket";
import { SocketTopics } from "@shared/types";
import { DISPLAY_CURRENCIES } from "@shared/common/constants";

const useGraphDataSocket = (symbol?: string, exchange?: string) => {
  const displayCurrency = useSelector(selectDisplayCurrency);
  const args = useMemo(() => {
    return symbol && exchange
      ? { symbol, exchange, isAsset: !isContractsSymbol(symbol) }
      : skipToken;
  }, [symbol, exchange]);
  const socketGraphData = useSocket<SocketTopics.GRAPHS_DATA>(
    SocketTopics.GRAPHS_DATA,
    args,
    undefined,
    true
  );

  const changeIndex = displayCurrency === DISPLAY_CURRENCIES.BTC ? 1 : 0;
  const rawChange = socketGraphData?.value?.change;
  const change = Array.isArray(rawChange)
    ? rawChange?.[changeIndex]
    : rawChange;
  const graphData = socketGraphData?.value;

  return {
    graphData,
    change,
    timestamp: socketGraphData?.timestamp ?? 0,
  };
};

export default useGraphDataSocket;
